module.exports = __webpack_public_path__ + "media/images/logo-blue-78040a56fcfa83a677810a0bca47a0a9.svg";